module.exports = __webpack_public_path__ + "media/images/element/map-7ffbebbb244dc5a1ff026683742183bb.svg";